import React from 'react';
import cx from 'classnames';
import { sortBy } from 'lodash';

import { Amount } from 'components/pages/finance/shared/amount-view/Amount/Amount';

import './AdjustmentList.scss';

export const AdjustmentList = ({ expenses, expenseType }) => {
  return (
    <div className={cx('adjustment-list')} data-testid="adjustment-details-table">
      <div className="adjustment-grid-header-container">
        <span>Event ID</span>
        <span className="amount-row-item">{expenseType === 'Expense' ? 'Applied Amount' : 'Amount'}</span>
      </div>
      {sortBy(expenses, 'adjustmentSequence').map(row => (
        <div key={row.ledgerEventId} className="adjustment-grid-row">
          <span>{`${row.eventNumber}${row.adjustmentSequence ? `.${row.adjustmentSequence}` : ''}`}</span>
          <span className="amount-row-item">{<Amount coinsAmount={row.clientAmount} showDollarSign />}</span>
        </div>
      ))}
    </div>
  );
};
